import { USER_LOADED, USER_LOGGED_IN, USER_IMAGE_UPDATED, USER_UPDATED, USER_AVERAGES_LOADED} from "./types";
import UserRequests from './../requests/UserRequests';


export const UserLoaded = data => ({
    type: USER_LOADED,
    payload: data
  });

  export const UserAveragesLoaded = data => ({
    type: USER_AVERAGES_LOADED,
    payload: data
  });


  export const UserLoggedIn = data => ({
    type: USER_LOGGED_IN,
    payload: data
  });

  export const UserImageUpdated = data => ({
    type: USER_IMAGE_UPDATED,
    payload: data
  });

  export const UserUpdated = data => ({
    type: USER_UPDATED,
    payload: data
  });



  export const loadUser = ( session, args )=>
  {
    return function(dispatch, getState)
    {
      const params = {...args, ...{onSuccess : (data)=>{ return UserLoaded(data)} }}
      dispatch(
        new UserRequests(session).getOne(params)
      )
    }
  }

  export const loadUserAverages = ( session, args )=>
  {
    return function(dispatch, getState)
    {
      const params = {...args, ...{onSuccess : (data)=>{ return UserAveragesLoaded(data)} }}
      dispatch(
        new UserRequests(session).getAverages(params)
      )
    }
  }

  export const updateUserImage = ( session, args )=>
  {
    return function(dispatch, getState)
    {
      const params = {...args, ...{onSuccess : (data)=>{ return UserImageUpdated(data)} }}
      dispatch(
        new UserRequests(session).updateProfileImage(params)
      )
    }
  }

  export const updateUser = ( session, args )=>
  {
    return function(dispatch, getState)
    {
      const params = {...args, ...{onSuccess : (data)=>{ return UserUpdated(data)} }}
      dispatch(
        new UserRequests(session).update(params)
      )
    }
  }
